import {
    SET_WELCOME,
    SET_MARCA,
} from "@/views/home/store/types/types.js";

const mutations = {
    [SET_WELCOME]: (state, payload) => state.welcome = payload,
    [SET_MARCA]: (state, payload) => state.marca = payload
};

export default mutations